import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from '../../../services/services';
import formatTimestamp from "../../../assets/files/_timestamps";
import Autocomplete from "../Autocomplete/Autocomplete";

export default function Table({ title, refParam, columns, data, loading = false, totalItems = 0, tableOptions = {}, 
  setTableOptions = () => {}, 
  columnActions = [],
  rowActions = [],
  actionHandlers = {},
  actionContext = {},
  hasPermission = () => true}) {

  const { pushFilter, navigate } = actionContext;
  const { page } = useParams();

  const getFullImageUrl = (relativeUrl) => {
  if (!relativeUrl) return "";

  const mediaBaseUrl = api.defaults.baseURL.replace("/api", "");
  return `${mediaBaseUrl.replace(/\/$/, "")}/${relativeUrl.replace(/^\//, "")}`;
  };

  const visibleColumns = columns.filter(col => col.table_hidden !== true);
  const showActions = visibleColumns.length > 0;

  const goToPrevPage = () => {
  const newPage = Math.max(1, Number(tableOptions.page) - 1);
  setTableOptions(prev => ({ ...prev, page: newPage }));
  if (title === "Messages") {
    navigate(`/${title.toLowerCase()}/${refParam}/${newPage}`);
  } else {
    navigate(`/${title.toLowerCase()}/${newPage}`);
  }
};

const goToNextPage = () => {
  const maxPage = Math.ceil(totalItems / Number(tableOptions.itemsPerPage));
  const newPage = Math.min(maxPage, Number(tableOptions.page) + 1);
  setTableOptions(prev => ({ ...prev, page: newPage }));
  if (title === "Messages") {
    navigate(`/${title.toLowerCase()}/${refParam}/${newPage}`);
  } else {
    navigate(`/${title.toLowerCase()}/${newPage}`);
  }
};

  // =========================
  // SORT
  // =========================
  const handleSort = (field) => {
    setTableOptions((prev) => {
      if (prev.sortBy !== field) {
        return { ...prev, page: 1, sortBy: field, sortDesc: false };
      }
      if (!prev.sortDesc) {
        return { ...prev, page: 1, sortBy: field, sortDesc: true };
      }
      return { ...prev, page: 1, sortBy: "", sortDesc: false };
    });
  };
const username = localStorage.getItem("username");
    // =========================
  // PAGINATION
  // =========================
  useEffect(() => {
    const pageFromUrl = page ? Number(page) : 1;

    setTableOptions(prev => ({
      ...prev,
      page: pageFromUrl,
    }));
  }, [page, title]); // re-run if URL or title changes

  return (
    <div>
      <div className="data-table-scroll">
        {/*JSON.stringify(data)*/}
        <table className="data-table">
          <thead>
            <tr>
              {
              visibleColumns.map((col) => (
                <th
                  key={col.key}
                  className={`${col.sortable !== false ? "sortable" : "not-sortable"} ${tableOptions.sortBy === col.key ? "sorted" : ""}`}
                  onClick={() => col.sortable !== false && handleSort(col.key)}
                >
                  {col.label}
                  {col.sortable !== false && (
                  <span className="sort-icon">{tableOptions.sortDesc ? "↓" : "↑"}</span>
                  )}
                </th>
              ))}
              {showActions && (
              <th className="text-center">Actions</th>
              )}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length + 1} style={{ padding: 8, textAlign: "center" }}>
                  Loading...
                  <div className="spinner"></div>
                </td>
              </tr>
            ):
            data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            ) : (
            data.map((d, index) => (
              <tr key={`${d}-${index}`} do-hover={'user_id__profile_picture' in d ? "false" : "true"}
              style={{
                fontWeight: d.is_not_read ? "bold" : "normal"
              }}>
                {columns.map((col) => (
                  <td key={`${col.key}-${index}`}
                  style={{
                    ...(col.key === "user_id__profile_picture" && {
                      width: "100px",
                      borderRight: "1px solid rgba(189, 182, 182, 0.6)",
                      backgroundColor:"#f5f5f5"
                    }),
                    ...(col.key === "content" && {
                      width: "100%",
                    }),
                  }}>{/*col.key*/}
                    { col.key === "profile_picture" ? (
                      <div className="center">
                        <img
                          src={getFullImageUrl(d[col.key])}
                          alt="Profile"
                          style={{
                            width: "130px",
                            height: "130px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ): col.key === "user_id__profile_picture"? (
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "2px"
                      }}>      
                          <img
                            src={getFullImageUrl(d[col.key])}
                            alt="Profile"
                            style={{
                              width: 130,
                              height: 130,
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                          <p>{ d['username'] }</p>
                          <p>{ d['email'] }</p>
                        
                      </div>
                    ): col.key === "content"? (
                      <div style={{
                        marginTop: "-80px"
                      }}>         
                          <p style={{color: "#c48037", fontSize: "18px",}}><b>created_at : { formatTimestamp(d['created_at']) }</b></p>
                          <p style = {{marginBottom: "20px", marginTop: "20px"}}>{ d['content'] }</p>
                        
                      </div>
                    ): col.key === "parent_id" || col.key === "element_id"?(
                      <>
                        {d[col.key]}
                        {/* Column actions for this column */}
                        {columnActions
                        .filter(
                          a =>
                            a.key === col.key &&
                            (!a.permission || hasPermission(a.permission)) &&
                            d[col.key]
                        )
                        .map((a) => (
                          <button className="label-btn"
                          style={{ "--label-btn-color": "#1f86a0" }}
                            key={a.label}
                            onClick={() => {
                              actionHandlers[a.action]?.({
                                ...actionContext,
                                entity: d,
                              });
                            }}
                          >
                            ↖
                          </button>
                      ))}

                    </>
                    ):col.key === "created_at" ? (
                      formatTimestamp(d[col.key])
                    ):col.key === "updated_at" ? (
                      formatTimestamp(d[col.key])
                    ):col.key === "last_login" ? (
                      formatTimestamp(d[col.key])
                    ) :col.key === "is_not_read" ? (
                      <input
                        type="checkbox"
                        checked={d[col.key]}
                        disabled
                      />
                    ) : (
                      <div className="text-truncate">
                        {d[col.key]+""}
                      </div>
                    )}
                  </td>
                ))}

                <td className="button-cell">
                  {rowActions
                    .filter(a => 
                      (!a.permission || hasPermission(a.permission)) &&
                      (!a.onlyIfLessThanFiveMinutes || (d.is_less_than_five_minutes && d.username == username))
                    )
                    .map(a => {
                      // Determine button color based on label
                      let btnClass = "default-btn"; // default grey

                      // Determine button content
                      let content = a.label;

                      if (a.label === "Info") {
                        btnClass += " img_info"; // red button
                        content="";
                      }
                      else if (a.label === "Edit") {
                        btnClass += " img_edit"; // red button
                        content="";
                      }
                      else if (a.label === "Delete") {
                        btnClass += " img_delete"; // red button
                        content="";
                      }
                      else if (a.label === "Peek Risks") {
                        btnClass += " tablered"; // red button
                      } else {
                        btnClass += " tablegreen"; // green button (for all others)
                      }

                      return (
                        <button
                          key={a.key}
                          className={btnClass}
                          onClick={() => {
                            actionHandlers[a.action]?.({
                              ...actionContext,
                              entity: d,
                            });
                          }}
                        >
                          {/*JSON.stringify(d, null, 2)*/}
                          {content}
                        </button>
                      );
                    })}

                </td>
              </tr>
              ))
            )}

          </tbody>
        </table>
      </div>
      <div style={{ height: "16px" }}></div>
      
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end", // aligns everything to the right
        gap: "22px", // space between items
        width: "100%",
        margin: "0px -30px"
      }}>
        Rows per page:
        <Autocomplete
        style={{ "--autocomplete-width": "50px" }}
          mode="select" // non-editable dropdown
          value={tableOptions.itemsPerPage}
          onChange={(val) =>
            setTableOptions({
              ...tableOptions,
              itemsPerPage: Number(val),
              page: 1,
            })
          }
          placeholder="Select items per page"
          options={[5, 10, 25, 50, 100].map((n) => ({ label: String(n), value: n }))}
        />

        {Math.min((tableOptions.page - 1) * tableOptions.itemsPerPage + 1, totalItems)}–
        {Math.min(tableOptions.page * tableOptions.itemsPerPage, totalItems)} of {totalItems}

        <div style={{ display: "flex", gap: 4, justifyContent: "flex-end", alignItems: "center" }}>
          {/* Prev Button */}
          <button
            className={`label-btn ${tableOptions.page <= 1 ? "disabled" : ""}`}
            style={{
            "--label-btn-bg": "none",
            "--label-btn-hover-bg": "#d5d5d5",
            "--label-btn-color": "#1a1b1d",
            "--b-rds": "50%",
            "--label-btn-padding":"0px 0px",
            "--l-w":"32px",
            "--l-h":"32px",
            }}
            onClick={() => tableOptions.page > 1 && goToPrevPage()}
          >
            <svg viewBox="0 0 24 24" width="22" height="22">
              <path d="M15.41 7.41L10.83 12l4.58 4.59L14 18l-6-6 6-6z"></path>
            </svg>
          </button>

          {/* Next Button */}
          <button
            className={`label-btn ${tableOptions.page * tableOptions.itemsPerPage >= totalItems ? "disabled" : ""}`}
            style={{
            "--label-btn-bg": "none",
            "--label-btn-hover-bg": "#d5d5d5",
            "--label-btn-color": "#1a1b1d",
            "--b-rds": "50%",
            "--label-btn-padding":"0px 0px",
            "--l-w":"32px",
            "--l-h":"32px",
            }}
            onClick={() =>
              tableOptions.page * tableOptions.itemsPerPage < totalItems && goToNextPage()
            }
          >
            <svg viewBox="0 0 24 24" width="22" height="22">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path>
            </svg>
          </button>
        </div>

        <p><b>Current Page: </b>{tableOptions.page}</p>
      </div>
    </div>

  );
}
